import { type ReactNode } from 'react';
import { cn } from '@packages/shared/src/utils/cn/cn';

interface ProductCardV2SustainabilityIconsContainerProps {
  children?: ReactNode;
  className?: string;
}

export const ProductCardV2SustainabilityIconsContainer = ({
  children,
  className,
}: ProductCardV2SustainabilityIconsContainerProps) => (
  <ul
    className={cn(
      'relative z-10',
      '[grid-area:13/2/span_1/span_1]',
      'border-color-grey mt-1 flex gap-1 border-t px-2 pt-1',
      className,
    )}
  >
    {children}
  </ul>
);
